import * as actionTypes from "./actions";

export const initialState = {
  isOpen: [],
  defaultId: "default",
  defaultPath: "/dashboard/default",
  fontFamily: `'Roboto', sans-serif`,
  opened: true,
  borderRadius: 12,
};

const sideBarReducer = (state = initialState, action) => {
  let id;

  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id;
      return {
        ...state,
        isOpen: [id],
      };
    case actionTypes.SET_MENU:
      return {
        ...state,
        opened: action.opened,
      };
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily,
      };
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius,
      };
    default:
      return state;
  }
};

export default sideBarReducer;
